import { useEffect, useMemo, useState } from 'react'

import { useMainStore } from '@/modules/shared/stores/main.store'

import { MemoizedMap } from '../components/maps/memoized-map'
import { getNearbyCustomersService } from '../services/get-nearby-customers.service'
import type { NearbyCustomer } from '../types/nearby-customers'

export const NearbyCustomersInterface = () => {
  const [location, setLocation] = useState({ lat: null, lon: null })
  const [error, setError] = useState(null)
  const [customers, setCustomers] = useState<NearbyCustomer[]>([])
  const [distance, setDistance] = useState(10)

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          })
        },
        (error) => {
          setError(error.code)
        },
      )
    } else {
      setError('Geolocation is not supported by this browser.')
    }
  }, [])

  const {
    actions: { setIsLoading },
  } = useMainStore()

  const handleGetCustomers = async () => {
    const data = await getNearbyCustomersService({
      lat: location.lat,
      long: location.lon,
      distance,
    })

    setCustomers(JSON.parse(data.data.body))
  }

  useEffect(() => {
    if (location.lat && location.lon) {
      handleGetCustomers()
    }
  }, [location])

  useEffect(() => {
    if (!location.lat || !location.lon) {
      return
    }

    const timer = setTimeout(() => {
      handleGetCustomers()
    }, 1000)

    return () => clearTimeout(timer)
  }, [distance, location])

  const memoizedMap = useMemo(() => {
    if (location.lat && location.lon) {
      return (
        <MemoizedMap
          location={location}
          customers={customers}
          handleDistanceChange={(d) => setDistance(d)}
        />
      )
    }
    return null
  }, [location, customers])

  useEffect(() => {
    if (!memoizedMap && !error) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
    }
  }, [error, memoizedMap])

  return (
    <div>
      {memoizedMap || (
        <div className="flex flex-1 items-center justify-center h-screen">
          {error === 1 ? (
            <p> O usuário negou a permissão de localização </p>
          ) : (
            <p>{error === 2 && 'Localização indisponível'}</p>
          )}
        </div>
      )}
    </div>
  )
}
